import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 22H2V13H11V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 22H13V13H22V22Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11 11H2V2H11V11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.4551 4.54395L22.6797 6L19.4551 7.45508L18 10.6797L16.5439 7.45508L13.3203 6L16.5439 4.54395L18 1.32031L19.4551 4.54395Z"}}]};

const AiToolFilled = Vue.extend<IconProps>({
  name: 'AiToolFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-tool-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiToolFilled;
